module.exports = __webpack_public_path__ + "img/match-logo-4.9081325f.png";